import Button from 'Button';

type Props = {
    color: 'primary' | 'purple';
    onPressCta: () => void;
    ctaText: string;
    ctaDisabled?: boolean;
};

export function ImportantCtaBoxCta({ color, onPressCta, ctaText, ctaDisabled }: Props) {
    return (
        <div data-id="important-cta-box-cta-container" className="flex justify-center">
            <Button radius="full" color={color} height={9} onPress={onPressCta} isDisabled={ctaDisabled}>
                {ctaText}
            </Button>
        </div>
    );
}
